import { render, staticRenderFns } from "./SelectGame.vue?vue&type=template&id=45c1f4a6&scoped=true&"
import script from "./SelectGame.vue?vue&type=script&lang=js&"
export * from "./SelectGame.vue?vue&type=script&lang=js&"
import style0 from "./SelectGame.vue?vue&type=style&index=0&id=45c1f4a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c1f4a6",
  null
  
)

export default component.exports